import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

// Async thunk for fetching location heat data
export const getVeloxityAudienceLocationHeat = createAsyncThunk(
    "getVeloxityAudienceLocationHeat",
    async ({ audienceId, gridType }, thunkAPI) => {
        try {
            const apiClient = new APIClient();

            const response = await apiClient.get(
                `/api/v1/analytic/audience/${audienceId}/location-heat/${gridType}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


// Slice for managing location heat state
export const veloxityGetAudienceLocationHeatSlice = createSlice({
    name: "getVeloxityAudienceLocationHeat",
    initialState: {
        loading: true,
        payload: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getVeloxityAudienceLocationHeat.pending, (state) => {
            state.loading = true;
            state.payload = {};
        });
        builder.addCase(getVeloxityAudienceLocationHeat.fulfilled, (state, action) => {
            state.loading = false;
            state.payload = action.payload;
        });
        builder.addCase(getVeloxityAudienceLocationHeat.rejected, (state, action) => {
            state.loading = false;
            state.payload = {};
        });
    },
});

export default veloxityGetAudienceLocationHeatSlice.reducer;
